module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4w3ns"))).then(() => parcelRequire('9Lwss'));